import { Access } from './Acces.model';

export class UpdateAccessOnAsset{
  workspaceId: string;
  assetId: string;
  assetType: string;
  access: Access;

  constructor(workspaceId: string, assetId: string, assetType: string,access: Access) {
    this.workspaceId = workspaceId;
    this.assetId = assetId;
    this.assetType = assetType;
    this.access = access;
  }
}
